import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {timer} from 'rxjs';

@Component({
    selector: 'app-message-ui',
    templateUrl: './message-ui.component.html',
    styleUrls: ['./message-ui.component.scss']
})
export class MessageUIComponent implements OnInit {
    hasLoaded = false;
    messageStatusRoute = '/messageMonitor';
    messageRequestId: string | null = null;

    constructor(
        private router: Router
    ) {
        // Get messageRequestId from navigation state
        const navigation = this.router.getCurrentNavigation();
        this.messageRequestId = navigation?.extras?.state?.['messageRequestId'];
    }

    ngOnInit() {
        timer(1).subscribe(() => this.hasLoaded = true);

        // messageRequestId is only populated when FF_MessageType is on and the API used the V2 path.
        // Otherwise the message lives in V1 tables, so keep the default /messageMonitor route.
        if (this.messageRequestId) {
            this.messageStatusRoute = `/messageStatusV2/${this.messageRequestId}`;
        }
    }
}
